import type { IStore } from "~/state/store";
import type { TWasmMapHover } from "../wasm";
import type WasmStoreMapping from "../mapping";
import type CursorManager from "~/util/cursorManager";
import { updateMarker } from "~/state/map-content/state";

let hoverCursor = null;

function useCursor(cursor: string, data: TWasmMapHover, cursorManager: CursorManager) {
	if (data.type === "enter") {
		if (hoverCursor) {
			cursorManager.update(hoverCursor, cursor);
		} else {
			hoverCursor = cursorManager.add(cursor);
		}
	} else if (data.type === "leave") {
		hoverCursor && cursorManager.remove(hoverCursor);
		hoverCursor = null;
	}
}

export function onHover(data: TWasmMapHover, store: IStore, cursorManager: CursorManager, mapping: WasmStoreMapping) {
	//console.log("hover", data.poi ? `${data.poi.source}-${data.poi.id}` : data.wasmId, data.type);
	// vlastni body - hover nad markerem
	if (Mapy.getComponent("userMarks").isActive()) {
		if (data.type !== "move" && data.wasmId) {
			const storeId = mapping.getWasmToStoreId(data.wasmId);
			const { markers } = store.getState().mapContent;
			const userMarksMarker = markers.find(marker => marker.id === storeId);

			if (userMarksMarker?.type === "user-marks") {
				Mapy.getComponent("userMarks").getMain()?.sectionHighlight(data.type === "enter", userMarksMarker.customData?.order - 1);
				useCursor("grab", data, cursorManager);
			}
		}
	} else if (Mapy.getComponent("distanceMeter").isActive() && data.type !== "move" && data.wasmId) {
		const storeId = mapping.getWasmToStoreId(data.wasmId);
		const { markers, geometries } = store.getState().mapContent;
		const distanceMeterMarker = markers.find(marker => marker.id === storeId);
		const distanceMeterGeometry = geometries.find(geometry => geometry.id === storeId);

		if (distanceMeterMarker?.type === "measure-points" || distanceMeterMarker?.type === "measure-start") {
			Mapy.getComponent("distanceMeter").getMain()?.sectionHighlight(data.type === "enter", Math.max(distanceMeterMarker.customData?.index - 1, 0), true);
			useCursor("grab", data, cursorManager);
		}

		if (distanceMeterGeometry?.type === "measure-line") {
			Mapy.getComponent("distanceMeter").getMain()?.sectionHighlight(data.type === "enter", distanceMeterGeometry.customData?.index, true);
			useCursor("url(/img/distancemeter/add.png) 3 3, crosshair", data, cursorManager);
		}
	// nejaky jiny marker nebo geometrie, co jsme si sami dali do mapy
	} else if (data.wasmId && data.type !== "move") {
		const storeId = mapping.getWasmToStoreId(data.wasmId);
		const { markers, geometries } = store.getState().mapContent;
		const wasmMarker = markers.find(marker => marker.id === storeId);
		const wasmGeometry = geometries.find(geometry => geometry.id === storeId);

		if (wasmMarker) {
			// neco, co otevira POI nebo trvale nad mapou a veci z MM nebo aktivita
			if (wasmMarker.customData?.poi
				|| wasmMarker.customData?.dim
				|| wasmMarker.customData?.component === "activities"
			) {
				useCursor("pointer", data, cursorManager);
				// vysledky hledani
				if (wasmMarker.customData.search) {
					Mapy.getComponent("search").hoverItem({
						source: wasmMarker.customData.poi.source,
						id: wasmMarker.customData.poi.id,
						state: data.type,
					});
				// vec z MM, ale ne trvale nad mapou
				} else if (Mapy.getComponent("places").isActive && wasmMarker.customData.dim && wasmMarker.type !== "always-on-map") {
					Mapy.getComponent("places").highlightItem(data.type === "enter" ? wasmMarker.customData.dim : "");
				} else if (wasmMarker.customData?.component === "activities") {
					Mapy.getComponent("activities").highlight(data.type === "enter" ? wasmMarker.customData.customId : "");
				}
			// neco tahaciho - obvykle nic nedela, jen meni kurzor
			} else if (wasmMarker?.draggable) {
				useCursor("grab", data, cursorManager);
				// routovaci marker
				if (wasmMarker.customData?.route) {
					Mapy.CML.state = {
						route: {
							hoverInd: data.type === "enter" ? wasmMarker.customData.order - 1 : -1,
						},
					};
				}
			}
		}

		if (wasmGeometry) {
			// geometrie routovace
			if (Mapy.getComponent("route").isActive() && wasmGeometry.customData?.route?.routeIndex !== undefined) {
				// aktualni zvolena route reaguje na hover
				if (wasmGeometry.customData?.route && (wasmGeometry.customData.route.routeIndex === Mapy.CML.state.route.index)) {
					markers.forEach(marker => {
						if (marker.customData?.route) {
							store.dispatch(updateMarker({
								id: marker.id,
								data: data.type === "enter"
									? {
										lastChange: marker.lastChange + 1,
										callback: "none",
										visual: "opacity",
										draggable: false,
									}
									: {
										lastChange: marker.lastChange + 1,
										callback: "click-hover",
										visual: "standard",
										draggable: true,
									},
							}));
						}
					});
				// prepinani alternativy v routovaci
				} else {
					useCursor("pointer", data, cursorManager);
				}
			} else if (Mapy.getComponent("places").isActive && wasmGeometry.customData.dim) {
				Mapy.getComponent("places").highlightItem(data.type === "enter" ? wasmGeometry.customData.dim : "");
				useCursor("pointer", data, cursorManager);
			}
		}
	// TODO: hover na panorama dostupnost
	/*} else if (data.rasterLayer === "panoLayer") {
		useCursor("pointer", data, cursorManager);*/
	// hover nad necim, co otevira POI
	} else if (data.poi && data.type !== "move") {
		useCursor("pointer", data, cursorManager);
	}
}
